import styles from "./myHeader.module.scss";
import Link from "next/link";
import { useState, useEffect } from "react";
import { useRouter } from "next/router";

const MyHeader = () => {
  const router = useRouter();
  const [active, setActive] = useState();
  const [homeNav, setHomeNav] = useState(
    router.pathname === "/" ? "homeNavnotFixed" : "homeNavFixed"
  );
  const isHome = router.pathname === "/" ? true : false;
  const urlArr = [
    {
      name: "Phone Number",
      path: "/phone-number.html",
    },
    {
      name: "Free Calls & Texts",
      path: "/free-calls-and-free-texts.html",
    },
    {
      name: "Rate & Plan",
      path: "/rates-plans.html",
    },
    {
      name: "Download",
      path: "/dingtone-free-download.html",
    },
    {
      name: "Add Credts",
      path: "/en/buy/",
    },
  ];
  // 初始化导航选中状态
  const getCurrentPath = (path) => {
    return urlArr.filter((item) => {
      return item.path.includes(path);
    });
  };
  // 设置菜单初始化样式
  const setNav = () => {
    if (getScrollTop() > 1000) {
      setHomeNav("homeNavFixed");
    } else {
      setHomeNav("homeNavnotFixed");
    }
  };
  // 获取滚动条的高度
  const getScrollTop = () => {
    var scroll_top = 0;
    if (document.documentElement && document.documentElement.scrollTop) {
      scroll_top = document.documentElement.scrollTop;
    } else if (document.body) {
      scroll_top = document.body.scrollTop;
    }
    // console.log(scroll_top)
    return scroll_top;
  };
  // ga统计
  const gaEvent = () => {
    var _gaq = _gaq || [];
    _gaq.push(["_setAccount", "UA-29757841-1"]);
    _gaq.push(["_trackPageview"]);
    _gaq.push(function () {
      setTimeout("doRedirect()", 50);
    });

    (function () {
      var ga = document.createElement("script");
      ga.type = "text/javascript";
      ga.async = true;
      ga.src =
        ("https:" == document.location.protocol
          ? "https://ssl"
          : "http://www") + ".google-analytics.com/ga.js";
      var s = document.getElementsByTagName("script")[0];
      s.parentNode.insertBefore(ga, s);
    })();

    //bruce-2020-6-15  上面Ga创建失效了，考虑历史性暂时不删除
    (function (i, s, o, g, r, a, m) {
      i["GoogleAnalyticsObject"] = r;
      (i[r] =
        i[r] ||
        function () {
          (i[r].q = i[r].q || []).push(arguments);
        }),
        (i[r].l = 1 * new Date());
      (a = s.createElement(o)), (m = s.getElementsByTagName(o)[0]);
      a.async = 1;
      a.src = g;
      m.parentNode.insertBefore(a, m);
    })(
      window,
      document,
      "script",
      "https://www.google-analytics.com/analytics.js",
      "ga"
    );

    ga("create", "UA-29757841-1", "auto");
    ga(
      "send",
      "event",
      "dingtone_website",
      "dingtone_website",
      location.href,
      1
    );
  };
  // 移动端跳转
  const goMobile = () => {
    if (/iPhone|iPad|iPod|Android/i.test(navigator.userAgent)) {
      var redirectMap = {
        "/": "/men",
        "/phone-number": "/men/phone-number.html",
        "/free-calls-and-free-texts": "/men/free-calls-and-free-texts.html",
        "/rates-plans": "/men/rates-plans.html",
        "/dingtone-free-download": "/men/dingtone-free-download.html",
        "/support": "/men/support.html",
        "/privacy_policy": "/men/privacy_policy.html",
        "/Terms_of_Service": "/men/Terms_of_Service.html",
        "/dingtone-free-download": "/men/download.html",
      };

      let pathname = window.location.pathname.replace(/\.html/, "");
      // console.log(pathname,redirectMap[pathname])
      redirectMap[pathname] && (window.location.href = redirectMap[pathname]);
    }
  };

  useEffect(() => {
    console.log(window.location.pathname.replace(/\.html/, ""));

    goMobile();

    if (router.pathname != "/" && getCurrentPath(router.pathname).length > 0) {
      setActive(getCurrentPath(router.pathname)[0].path);
    }

    gaEvent();

    window.onscroll = () => {
      if (router.pathname === "/") {
        setNav();
      }
    };
  }, []);
  return (
    <header
      className={styles.header + " " + styles[isHome ? homeNav : "notHomeNav"]}
    >
      <div className="main">
        <div className="navList">
          <ul>
            <li>
              <Link href="http://blog.dingtone.me/en/">
                <a>Blog</a>
              </Link>
            </li>
            <li>
              <span>|</span>
            </li>
            <li>
              <Link href="http://www.twitter.com/dingtone">
                <a>Twitter</a>
              </Link>
            </li>
          </ul>
        </div>
        <div className={styles.bottomNav}>
          <Link href="/">
            <a>
              <img src="/img/nav_logo.png" alt="logo" />
            </a>
          </Link>
          <ul>
            {urlArr.map((item, index) => (
              <li
                className={styles[active === item.path ? "active" : ""]}
                key={index}
              >
                <Link href={item.path}>
                  <a>{item.name}</a>
                </Link>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </header>
  );
};
export default MyHeader;
